module.exports = __webpack_public_path__ + "img/oblique-480-60.4cb6f2ae.jpg";